<template>
  <div class="row input-wrapper">
    <div class="col-md-4" v-for="field in normalizedFields" :key="field.key">
      <label :for="field.key">{{ field.label }}</label>

      <template v-if="field.type === 'select'">
        <select
          class="form-control"
          v-model="field.value"
          :disabled="field.disabled || disabled"
          @change="handleChange($event, field)"
        >
          <option value="">Select an option</option>
          <option
            v-for="option in getOptions(field.key)"
            :key="option.key"
            :value="option.key || option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </template>

      <template v-else-if="field.key === 'bvnValid' || field.key === 'nin'">
        <div class="input-group">
          <input
            type="text"
            v-model="field.value"
            class="form-control"
            :placeholder="
              shouldHavePlaceholder(field) ? `Enter ${field.label}` : ''
            "
            :disabled="field.disabled || disabled"
          />
          <div
            class="input-group-append"
            :style="{ display: isAgent ? 'none' : 'block' }"
          >
            <button class="btn btn-primary" @click="handleClick(field)">
              {{
                field.key === "bvnValid"
                  ? isBvnVisible
                    ? "Hide"
                    : "View"
                  : isNinVisible
                  ? "Hide"
                  : "View"
              }}
            </button>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="input-group">
          <input
            type="text"
            v-model="field.value"
            class="form-control"
            :placeholder="
              shouldHavePlaceholder(field) ? `Enter ${field.label}` : ''
            "
            :disabled="field.disabled || disabled"
            :maxlength="field.key === 'businessPhoneNumber' ? 11 : undefined"
            @input="handleFieldInput(field)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { handleInput } from "../../utils/utils";

export default {
  data() {
    return {
      userType: localStorage.getItem("Merchant"),
    };
  },
  props: {
    fields: [Array, Object],
    disabled: {
      type: Boolean,
      default: true,
    },
    getOptions: {
      type: Function,
      required: false,
      default: () => () => [],
    },
    onChange: {
      type: Function,
      required: false,
      default: () => () => {},
    },
    onClick: {
      type: Function,
      required: false,
      default: null,
    },
  },
  computed: {
    isAgent() {
      return this.userType === "super-admin";
    },
    normalizedFields() {
      return Array.isArray(this.fields) ? this.fields : [this.fields];
    },
    isBvnVisible() {
      return this.$parent.isBvnVisible;
    },
    isNinVisible() {
      return this.$parent.isNinVisible;
    },
  },
  methods: {
    handleChange(event, field) {
      if (this.onChange) {
        this.onChange(event.target.value, field.key);
      }
    },
    handleFieldInput(field) {
      const validationErrors = {};
      handleInput(field, validationErrors);
      this.validation = { ...this.validation, ...validationErrors };
    },
    shouldHavePlaceholder(field) {
      const noPlaceholderFields = ["activatedAt", "activitedBy"];
      return !noPlaceholderFields.includes(field.key);
    },

    handleClick(field) {
      if (this.onClick && typeof this.onClick === "function") {
        this.onClick(field);
      }
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  row-gap: 15px;
}

label {
  color: #9a9a9a;
  font-size: 10px;
}

select,
input {
  background-color: #fafafa;
  font-size: 10px;
}

input:disabled,
select:disabled {
  background-color: #f5f5f5;
  color: #71797e;
}

input::placeholder {
  color: #b6b6b4 !important;
  font-size: 10px !important;
}
</style>
